import Emitter from "@homer.core/emitter";
import clientState from "@homer.core/client.state";
import StorageCookie from "@homer.core/storage.cookie";
import StorageLocal from "@homer.core/storage.local";
import Uuid from "@homer.utility/uuid";
import { name } from "../package.json";

const storageCookieUuid = new StorageCookie("uuid", {
    /* no versioning here due to uuid */
    lifetime: 183 * 24 * 60 * 60,
    encode: false,
});
const storageCookie = new StorageCookie(name, {
    /* no versioning here due to uuid */
    lifetime: 183 * 24 * 60 * 60,
});
const storageLocal = new StorageLocal(name, {
    /* no versioning here due to uuid */
});
const timestamp = {
    current: +new Date(),
    previous: +new Date(),
};
const defaultState = JSON.stringify({
    current: {
        id: undefined,
        start: timestamp.current,
        expires: timestamp.current + 30 * 60 * 1000,
        count: 0,
        views: 0,
        conversions: 0,
        engagement: 0,
        isNewVisitor: false,
        isNewSession: false,
        isEngaged: false,
    },
    previous: {
        id: undefined,
        start: timestamp.current,
        expires: timestamp.current + 30 * 60 * 1000,
        count: 0,
        views: 0,
        conversions: 0,
        engagement: 0,
        isNewVisitor: false,
        isNewSession: false,
        isEngaged: false,
    },
});
let absent = 0;

const getState = () => {
    const uuid = storageCookieUuid.get() || undefined;
    const { current, previous } = (() => {
        try {
            return JSON.parse(storageCookie.get() || storageLocal.get() || defaultState) || JSON.parse(defaultState);
        } catch (error) {
            return JSON.parse(defaultState);
        }
    })();

    return {
        current: { ...current, uuid: uuid || current.uuid || previous.uuid || undefined },
        previous: { ...previous, uuid: uuid || current.uuid || previous.uuid || undefined },
    };
};

const generateID = () => {
    return `${Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)}.${timestamp.current / 1000}`;
};

class Session extends Emitter {
    constructor() {
        super();

        clientState.on("present", (event, details) => {
            absent += details.retention;
        });
    }

    update(value = 0, flag) {
        const state = getState();
        const current = { ...state.current };
        const previous = state.current;

        timestamp.previous = timestamp.current;
        timestamp.current = +new Date();

        current.isNewVisitor = !current.uuid;
        current.uuid = current.isNewVisitor ? Uuid.generate() : current.uuid;
        current.isNewSession = !current.id || current.isNewVisitor || timestamp.current > current.expires;

        if (current.isNewSession) {
            current.id = generateID();
            current.start = timestamp.current;
            current.count = (current.count || 0) + 1;
            current.views = 0;
            current.conversions = 0;
            current.isEngaged = false;
        }

        if (value & flag.isPageview) {
            current.views += 1;
        }

        if (value & flag.isConversion) {
            current.conversions += 1;
        }

        current.expires = timestamp.current + 30 * 60 * 1000;
        current.engagement = value & flag.isPageview ? 0 : Math.max(0, timestamp.current - timestamp.previous - absent);
        current.isEngaged = current.isEngaged || current.views >= 2 || current.conversions > 0 || current.engagement >= 10000;

        absent = 0;

        storageCookieUuid.set(current.uuid);
        storageCookie.set(JSON.stringify({ current, previous }));
        storageLocal.set(JSON.stringify({ current, previous }));
        this.emit("change", Object.freeze(current), Object.freeze(previous));
    }

    get current() {
        return Object.freeze({ count: 1, ...getState().current });
    }

    get previous() {
        return Object.freeze({ count: 1, ...getState().previous });
    }
}

export default new Session();
